import * as React from "react";
import ReactMarkdown from "react-markdown";

export const SplitContent = ({ Output }) => {
	const splitContent = Output.match(RegExp("(.*[^#}]+)", "g")).filter((e) =>
		e.includes("#")
	);
	return splitContent;
};

export const Headings = ({ Output }) => {
	const splitContent = Output.match("(?<=(^#)s).*");
	return Output;
};

export const Markdown = ({ Output, ...options }) => {
	const heading = {
		h1: ({ node, ...props }) => {
			if (options?.ignoreHeadings) {
				return null;
			} else {
				if (options?.replaceH1) {
					return <h2 className="text-2xl text-blue-500 my-4" {...props} />;
				} else {
					return <h1 className="text-4xl text-blue-500 my-4" {...props} />;
				}
			}
		},

		h2: ({ node, ...props }) => {
			if (options?.ignoreHeadings) {
				return null;
			} else {
				if (options?.id) {
					return (
						<div id={props.children[0]}>
							<h2 className="text-2xl text-blue-500 my-4" {...props} />
						</div>
					);
				} else {
					return <h2 className="text-2xl text-blue-500 my-4" {...props} />;
				}
			}
		},

		h3: ({ node, ...props }) => {
			if (options?.ignoreHeadings) {
				return null;
			} else {
				if (options?.id) {
					return (
						<div id={props.children[0]}>
							<h3 className="text-xl text-blue-500 my-4" {...props} />
						</div>
					);
				} else {
					return <h3 className="text-xl text-blue-500 my-4" {...props} />;
				}
			}
		},
		h4: ({ node, ...props }) => {
			if (options?.ignoreHeadings) {
				return null;
			} else {
				if (options?.id) {
					return (
						<div id={props.children[0]}>
							<h3 className="text-xl text-blue-500 my-4" {...props} />
						</div>
					);
				} else {
					return <h3 className="text-xl text-blue-500 my-4" {...props} />;
				}
			}
		},
		h5: ({ node, ...props }) => {
			if (options?.ignoreHeadings) {
				return null;
			} else {
				if (options?.id) {
					return (
						<div id={props.children[0]}>
							<h3 className="text-xl text-blue-500 my-4" {...props} />
						</div>
					);
				} else {
					return <h3 className="text-xl text-blue-500 my-4" {...props} />;
				}
			}
		},
		h6: ({ node, ...props }) => {
			if (options?.ignoreHeadings) {
				return null;
			} else {
				if (options?.id) {
					return (
						<div id={props.children[0]}>
							<h3 className="text-xl text-blue-500 my-4" {...props} />
						</div>
					);
				} else {
					return <h3 className="text-xl text-blue-500 my-4" {...props} />;
				}
			}
		},
	};

	const others = {
		p: ({ node, ...props }) => {
			if (options?.ignoreOthers) {
				return null;
			} else {
				return <p className="mt-4 text-xl text-gray-700" {...props} />;
			}
		},
		ul: ({ node, ...props }) => {
			if (options?.ignoreOthers) {
				return null;
			} else {
				return <ul className="list-disc list-inside" {...props} />;
			}
		},
		li: ({ node, ...props }) => {
			if (options?.ignoreOthers) {
				return null;
			} else {
				return <li className="mt-4 text-xl text-gray-700" {...props} />;
			}
		},
	};

	var allcomponents = { ...heading, ...others };

	return <ReactMarkdown children={Output} components={allcomponents} />;
};
